import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-branded',
    templateUrl: 'hc-branded.html',
    providers: []
})
export class HcBranded {

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    constructor(public element: ElementRef) {

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-branded/hc-branded.ts